export default __webpack_public_path__ + "images/0ce18d7c82d043f3242149aabeae3a91-education.webp";